export const CANVAS_ACCESS_META_REQUEST = 'CANVAS_ACCESS_META_REQUEST'
export const CANVAS_ACCESS_META_SUCCESS = 'CANVAS_ACCESS_META_SUCCESS'
export const CANVAS_ACCESS_META_FAILURE = 'CANVAS_ACCESS_META_FAILURE'
